import { useCallback, useState } from 'react';

import { useSSRQuery } from '../graphql';
import { useMutation } from '@apollo/react-hooks';

import LAST_COMPLETED_BOOKING_STEP_QUERY from './useLastCompletedBookingStep/lastCompletedBookingStep.query.graphql.js';
import UPDATE_LAST_COMPLETED_BOOKING_STEP_MUTATION from './useLastCompletedBookingStep/updateLastBookingStepCompleted.mutation.graphql.js';

const useLastCompletedBookingStep = () => {
  const [lastStepCompleted, setLastStepCompletedState] = useState();
  const cartOverride = 'CART-OVERRIDE';

  useSSRQuery(LAST_COMPLETED_BOOKING_STEP_QUERY, {
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    onCompleted: data => {
      setLastStepCompletedState(data?.application?.lastBookingStepCompleted);
    },
  });

  const [updateLastBookingStepCompleted] = useMutation(
    UPDATE_LAST_COMPLETED_BOOKING_STEP_MUTATION,
    {
      onCompleted: data => {
        const lastStepMarkedAsComplete =
          data?.updateLastBookingStepCompleted?.step;
        setLastStepCompletedState(lastStepMarkedAsComplete);
      },
    }
  );

  const setLastStepCompleted = useCallback(
    step => {
      if (step === cartOverride) {
        // changing the lastStepCompleted state as qgl query is not there for CART-OVERRIDE
        setLastStepCompletedState(cartOverride);
      } else {
        updateLastBookingStepCompleted({
          variables: {
            step: step,
          },
        });
      }
    },
    [updateLastBookingStepCompleted]
  );

  return {
    lastStepCompleted,
    setLastStepCompleted,
  };
};

export default useLastCompletedBookingStep;
